/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthPlatformRemotePatientSearchPayload
 */
export interface AuthPlatformRemotePatientSearchPayload {
    /**
     * 
     * @type {string}
     * @memberof AuthPlatformRemotePatientSearchPayload
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthPlatformRemotePatientSearchPayload
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthPlatformRemotePatientSearchPayload
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthPlatformRemotePatientSearchPayload
     */
    member_number?: string;
}

/**
 * Check if a given object implements the AuthPlatformRemotePatientSearchPayload interface.
 */
export function instanceOfAuthPlatformRemotePatientSearchPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthPlatformRemotePatientSearchPayloadFromJSON(json: any): AuthPlatformRemotePatientSearchPayload {
    return AuthPlatformRemotePatientSearchPayloadFromJSONTyped(json, false);
}

export function AuthPlatformRemotePatientSearchPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthPlatformRemotePatientSearchPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'member_number': !exists(json, 'member_number') ? undefined : json['member_number'],
    };
}

export function AuthPlatformRemotePatientSearchPayloadToJSON(value?: AuthPlatformRemotePatientSearchPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'member_number': value.member_number,
    };
}

